import { AwsUi } from '../../../core/runtime/src';
import { Icon } from '../../icon/src';
export var TokenToggle = function (_a) {
    var controlId = _a.controlId, areAllHidden = _a.areAllHidden, isExpanded = _a.isExpanded, numberOfHiddenOption = _a.numberOfHiddenOption, onClick = _a.onClick, _b = _a.i18nStrings, _c = _b === void 0 ? { tokenLimitShowMore: '' } : _b, tokenLimitShowFewer = _c.tokenLimitShowFewer, tokenLimitShowMore = _c.tokenLimitShowMore;
    var numberOfHiddenOptionLabel = areAllHidden ? numberOfHiddenOption : "+" + numberOfHiddenOption;
    var description = tokenLimitShowMore + " (" + numberOfHiddenOptionLabel + ")";
    var iconName = 'treeview-expand';
    if (isExpanded) {
        description = tokenLimitShowFewer;
        iconName = 'treeview-collapse';
    }
    return (AwsUi.__createElement("button", { type: "button", className: "awsui-multiselect__token-toggle", "override-focus": true, onclick: onClick, "aria-controls": controlId, "aria-expanded": isExpanded.toString() },
        AwsUi.__createElement(Icon, { name: iconName, variant: "link" }),
        AwsUi.__createElement("span", { className: "awsui-multiselect__token-toggle-description" }, description)));
};
//# sourceMappingURL=token-toggle.js.map